module.exports = __webpack_public_path__ + "img/03-defaul.88244cb1.png";